import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { AuthService, LoHiUserInfo } from '../root/auth.service';

@Directive({
  selector: '[lohiRelationship]',
})
export class RelationshipDirective implements OnInit, OnDestroy {
  private subscription: Subscription;
  private hasView = false;
  private relationships$$ = new BehaviorSubject<string[]>([]);

  @Input()
  public set lohiRelationship(relationships: string | string[]) {
    if (Array.isArray(relationships)) {
      this.relationships$$.next(relationships);
    } else {
      this.relationships$$.next([relationships]);
    }
  }

  constructor(
    private authService: AuthService,
    private cd: ChangeDetectorRef,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {}

  public ngOnInit() {
    this.setup();
  }

  public ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setup() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = combineLatest([this.authService.userInfo$, this.relationships$$]).subscribe(
      ([user, relationships]) => {
        const matches = hasRelationship(user, relationships);
        if (matches) {
          if (!this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
            this.cd.markForCheck();
          }
        } else {
          if (this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
            this.cd.markForCheck();
          }
        }
      },
    );
  }
}

function hasRelationship(user: LoHiUserInfo, relationships: string[]): boolean {
  if (!user || !user.accountRelationship || !relationships || relationships.length === 0) {
    return false;
  }
  return relationships.includes(user.accountRelationship);
}
